import { atom } from "jotai";

// True while POST /organizations/{id}/payment-methods is in flight (#375).
export const isProcessingPaymentMethodAtom = atom<boolean>(false);
